if (!customElements.get('td-sticky-atc')) {
  class TdStickyAtc extends HTMLElement {
    constructor() {
      super();

      this.ACTIVE_CLASS = 'td-active';
    }

    connectedCallback() {
      this.ATC_BUTTON = this.querySelector('[data-sticky-atc-button]');
      this.ATC_PRICE = this.querySelector('.td-sticky-atc__price');
      this.FORM_ATC_BUTTON = document.querySelector('.product__add-to-cart');
      this.OBSERVABLE_TARGET = document.querySelector('[data-sticky-atc-observable]');
      this.ACTIVE_CLASS = 'td-active';
      this.OPTION_SELECTS = this.querySelectorAll('[data-sticky-atc-option-selector]');
      this.PRODUCT_FORM_OPTIONS = this.querySelectorAll('product-variants .product-variant__input');

      this.SELLING_PLAN_SELECT = this.querySelector('[data-sticky-atc-plan-group]');
      this.SELLING_PLAN_INPUT = document.querySelector('[data-selling-plan-input]');
      this.SKIO_COMPONENT = document.querySelector('skio-plan-picker');
      
      if (!this.ATC_BUTTON || !this.ATC_PRICE || !this.FORM_ATC_BUTTON || !this.OBSERVABLE_TARGET) {
        return
      }
      this.attachListeners();
      if (this.SELLING_PLAN_SELECT && this.SKIO_COMPONENT && this.SELLING_PLAN_INPUT) {
        this.SKIO_SHADOW_ROOT = this.SKIO_COMPONENT.shadowRoot;
        if (this.SKIO_SHADOW_ROOT) {
          this.reflectSellingPlan();
          this.attachSkioRelatedListeners();
        }
      }
    }

    attachListeners() {
      window.addEventListener("scroll", (event) => {
        this.toggleAtcContainer();
      });
      this.ATC_BUTTON.addEventListener("click", (event) => {
        this.FORM_ATC_BUTTON.click();
      });
      window.addEventListener("td:price-changed", (event) => {
        this.updateAtcPrice(event);
      });
      window.addEventListener("td:variant-changed", (event) => {
       this.reflectSelectedOptions(event);
      });
      this.OPTION_SELECTS.forEach(select => {
        select.addEventListener("change", (event) => {
          this.setSelectedOptions(event);
        });
      });
      
    }

    attachSkioRelatedListeners() {
      this.SELLING_PLAN_INPUT.addEventListener("change", (event) => {
        this.reflectSellingPlan();
      });
      this.SELLING_PLAN_SELECT.addEventListener("change", (event) => {
        this.setSellingPlan();
      });
    }

    toggleAtcContainer() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting || this.isCloseToTopOrBottomOfDocument()) {
            this.classList.remove(this.ACTIVE_CLASS);
          } else {
            this.classList.add(this.ACTIVE_CLASS);
          }
        });
      });
      observer.observe(this.OBSERVABLE_TARGET);
    }

    isCloseToTopOrBottomOfDocument(offset = 250) {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      const isCloseToTop = scrollPosition <= offset;

      const isCloseToBottom = documentHeight - (scrollPosition + windowHeight) <= offset;

      return isCloseToTop || isCloseToBottom;
    }

    setSellingPlan() {
      const selectedOption = this.SELLING_PLAN_SELECT.options[this.SELLING_PLAN_SELECT.selectedIndex];
      const sellingPlanId = selectedOption.dataset.stickyAtcPlan;
      if (sellingPlanId === 'one-time-purchase') {
        const sellingPlanGroupRadio = this.SKIO_SHADOW_ROOT.querySelector(`#${this.SELLING_PLAN_SELECT.dataset.stickyAtcOneTime}`);
        if (!sellingPlanGroupRadio) {return}
        sellingPlanGroupRadio.checked = true;
        sellingPlanGroupRadio.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        const sellingPlanGroupRadio = this.SKIO_SHADOW_ROOT.querySelector(`#${this.SELLING_PLAN_SELECT.dataset.stickyAtcPlanGroup}`);
        const sellingPlanRadio = this.SKIO_SHADOW_ROOT.querySelector(`#selling_plan_button-${sellingPlanId}`);
        if (!sellingPlanGroupRadio || !sellingPlanRadio) {return}
        sellingPlanRadio.checked = true;
        sellingPlanGroupRadio.checked = true;
        sellingPlanRadio.dispatchEvent(new Event('change', { bubbles: true }));
        sellingPlanGroupRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    reflectSellingPlan() {
      if (this.SELLING_PLAN_INPUT.value.trim() === '') {
        this.SELLING_PLAN_SELECT.value = 'one-time-purchase';
      } else {
        this.SELLING_PLAN_SELECT.value = this.SELLING_PLAN_INPUT.value;
      }
    }

    updateAtcPrice(event) {
      const price = event?.detail?.price;
      if (price) {
        this.ATC_PRICE.innerHTML = price;
      }
    }

    setSelectedOptions(event) {
      const optionToSelect = document.querySelector(`.product-variant__item input[value="${event?.target?.value}"]`);
      if (optionToSelect) {
        optionToSelect.checked = true;
        optionToSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      //Handle custom option selectors
      document.querySelectorAll(`.product_custom_var span[data-value]`).forEach(option => {
        option.classList.remove('active');
      });
      const customOptionToSelect = document.querySelector(`.product_custom_var span[data-value="${event?.target?.value}"]`);
      if (customOptionToSelect) {
        customOptionToSelect.classList.add('active');
      }
    }

    reflectSelectedOptions(event) {
      const selectedVariant = event?.detail?.selected_variant;
      if (!selectedVariant) {
        return;
      }
      selectedVariant.options.map((option, index) => {
        const optionSelect = this.OPTION_SELECTS[index];
        if (optionSelect) {
          optionSelect.value = option;
        }
      })
    }

  }

  customElements.define('td-sticky-atc', TdStickyAtc);
}
